<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/performanceProductLineList' }">绩效产品行</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <div>
                        <draggableDetail :draggable="{ data_name: 'performance_product_line' }" @isErrshow="reload"></draggableDetail>
                    </div>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="data" class="details" label-width="auto">
                        <template>
                            <el-row v-for="(item_out, index_out) in colData" :key="index_out">
                                <el-col :span="12" v-for="(item, index) in item_out" :key="index">
                                    <el-form-item :label="item.title ? item.title + '：' : ''">
                                        <div
                                            class="read_only read_only_link"
                                            v-if="
                                                in_array(item.prop, [
                                                    'performance_unit_name',
                                                    'product',
                                                    'performance_assignment_rid',
                                                    'ppa_code',
                                                    'partner',
                                                    'account',
                                                    'supplier',
                                                    'demander',
                                                    'representative'
                                                ])
                                            "
                                        >
                                            <span @click="toDetail(item.prop)">{{ data[item.prop] }}</span>
                                        </div>
                                        <el-input
                                            v-else
                                            v-model="data[item.prop]"
                                            class="flex_item_text"
                                            size="mini"
                                            readonly="readonly"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { onDelete, in_array, processColumnDataToRowNew } from '@/js/common';
import draggableDetail from '../../../common/DrawerDetail.vue';
export default {
    inject: ['reload'],
    name: 'performanceProductLineDetail',
    components: {
        draggableDetail
    },
    data() {
        return {
            colData: [],
            activeNames: ['1'],
            data: {},
            queryParams: {},
            headerTitle: '绩效产品行详情',
            flag: false
        };
    },
    watch: {
        $route(to, from) {
            this.queryParams.id = to.query.id;
            this.reload();
        }
    },
    beforeMount() {
        this.selectedColData(); //筛选列
        this.initQueryParams();
    },
    mounted() {
        this.$nextTick(() => {
            this.getData(); //获取详情
            this.flag = true;
        });
    },
    methods: {
        in_array,
        toDetail(prop) {
            if (in_array(prop, ['performance_unit_name']) && this.data.performance_unit_id) {
                this.$router.push({
                    path: '/performanceUnitDetail',
                    query: {
                        id: this.data.performance_unit_id
                    }
                });
            } else if (in_array(prop, ['product']) && this.data.product_rid) {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: this.data.product_rid
                    }
                });
            } else if (in_array(prop, ['performance_assignment_rid']) && this.data.performance_assignment_rid) {
                this.$router.push({
                    path: '/performanceAssignmentDetail',
                    query: {
                        id: this.data.performance_assignment_rid
                    }
                });
            } else if (in_array(prop, ['ppa_code']) && this.data.ppa_rid) {
                this.$router.push({
                    path: '/partnerProductAccountDetail',
                    query: {
                        id: this.data.ppa_rid
                    }
                });
            } else if (in_array(prop, ['partner']) && this.data.partner_rid) {
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: this.data.partner_rid
                    }
                });
            } else if (in_array(prop, ['account']) && this.data.account_rid) {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: this.data.account_rid
                    }
                });
            } else if (in_array(prop, ['supplier']) && this.data.supplier_rid) {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: this.data.supplier_rid
                    }
                });
            } else if (in_array(prop, ['demander']) && this.data.demander_rid) {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: this.data.demander_rid
                    }
                });
            } else if (in_array(prop, ['representative']) && this.data.representative_rid) {
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: this.data.representative_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams.id = this.$route.query.id;
        },
        //筛选列
        selectedColData() {
            let colData = JSON.parse(localStorage.getItem('detailList')).performance_product_line;
            processColumnDataToRowNew(colData, this);
        },
        //详情
        getData() {
            this.$api
                .performanceProductLineDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    document.title = this.headerTitle + ':' + res.data.id;
                })
                .catch((error) => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>